import { TeklifFiyatDegisiklik } from './teklif-fiyat-degisiklik';
import { TeklifGorsel } from './teklif-gorsel';
import { TeklifKalemGirRequest } from './teklif-kalem-gir-request';

export class TeklifGirRequest {

  teklifId: number;
  teslimYeriId: number;
  teslimSekliId: number;
  odemeYontemiId: number;
  teslimTarihi: Date;
  opsiyon: string;
  garantiSuresi: string;
  firmaTeklifNotu: string;
  kalemler: TeklifKalemGirRequest[];
  publicAccessKey: string;
  teslimSuresi: number;
  teklifFiyatDegisiklikler: TeklifFiyatDegisiklik[];
  teklifGorseller: TeklifGorsel[];

  constructor(obj?: any) {
    if (obj == null) {
      return;
    }
    Object.assign(this, obj);
  }
}
